import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const ORG_ROLE_LABELS = {
  admin: "Administrador",
  head_coach: "Head Coach",
  coach: "Coach",
  manager: "Manager",
  assistant: "Asistente",
};

export const formatOrgRole = (rol) => {
  if (!rol) return "";
  const normalized = rol.toLowerCase();
  return ORG_ROLE_LABELS[normalized] || rol;
};

const MOJIBAKE_PATTERN = /Ã|Â|â|�/;

export const fixMojibake = (value) => {
  if (value == null) return "";
  const text = String(value);
  if (!MOJIBAKE_PATTERN.test(text)) return text;
  try {
    const bytes = Uint8Array.from(text.split("").map((char) => char.charCodeAt(0)));
    const decoded = new TextDecoder("utf-8").decode(bytes);
    return decoded || text;
  } catch (error) {
    return text;
  }
};
